import { useContext } from 'react';
import { CartContext } from './ManageCartProvider';

const useManageCart = () => useContext(CartContext);

export default useManageCart;
